<template>
  <div class="template-b">
    <div class="chunk-list">
      <template v-if="data.length == 1">
        <div class="chunk-a" style="margin-left: 0"></div>
        <div class="chunk-b" @click="handleClick(data[0])">
          <img :src="data[0].icon" alt="" />
        </div>
      </template>
      <template v-if="data.length > 1">
        <div
          class="chunk-a"
          style="margin-left: 0"
          @click="handleClick(data[1])"
        >
          <img :src="data[1].icon" alt="" />
        </div>
        <div class="chunk-b" @click="handleClick(data[0])">
          <img :src="data[0].icon" alt="" />
        </div>
        <div class="secoed-container">
          <div class="left">
            <div class="chunk-a common-a" @click="handleClick(data[2])">
              <img :src="data[2].icon" alt="" />
            </div>
            <div class="chunk-a common-a ml5" @click="handleClick(data[3])">
              <img :src="data[3].icon" alt="" />
            </div>
            <div class="chunk-a common-a" @click="handleClick(data[5])">
              <img :src="data[5].icon" alt="" />
            </div>
            <div class="chunk-a common-a ml5" @click="handleClick(data[6])">
              <img :src="data[6].icon" alt="" />
            </div>
          </div>
          <div class="right">
            <div class="chunk-a common-a" @click="handleClick(data[4])">
              <img :src="data[4].icon" alt="" />
            </div>
          </div>
        </div>
        <div
          class="chunk-a common-a"
          :class="[index === 0 ? 'ml0' : '']"
          v-for="(item, index) in data.slice(8)"
          :key="item.id"
          @click="handleClick(item)"
        >
          <img :src="item.icon" alt="" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
// id 138 专用
export default {
  props: {
    data: {
      type: Array
    }
  },
  data () {
    return {}
  },
  methods: {
    handleClick (item) {
      if (item.jump_type == 1) {
        if (item.is_home == 1) {
          this.$router.push({
            path: '/detailIframe',
            query: {
              url: item.content_url,
              isHome: item.is_home,
              id: this.$route.query.id
            }
          })
        } else {
          // window.location.href = item.content_url
          window.go(item.content_url)
        }
      } else {
        this.$router.push({
          path: '/detail',
          query: {
            id: item.id,
            isHome: item.is_home
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.chunk-list {
  width: 100%;
  height: auto;
  padding: 0.2rem 0.48rem 0.2rem 0.48rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
// flex-wrap: wrap;
.chunk-a {
  cursor: pointer;
  margin-top: 0.5rem;
  margin-left: 5%;
  overflow: hidden;
  width: 30%;
  height: 4.5rem;
}

// .common-a:nth-child(3n) {
//     margin-left: 0rem !important;
// }

.chunk-b {
  cursor: pointer;
  margin-top: 0.5rem;
  margin-left: 5%;
  width: 65%;
  height: 4.5rem;
}
.chunk-b img,
.chunk-a img {
  width: 100%;
  height: 100%;
}

.secoed-container {
  width: 100%;
  display: flex;

  .left {
    flex: 1;
    display: flex;
    flex-wrap: wrap;

    .chunk-a {
      margin-left: 0;
      width: 45%;
    }
  }

  .right {
    margin-left: 5%;
    width: 30%;

    .chunk-a {
      width: 100%;
      height: 9.5rem;
      margin-left: 0;
    }
  }
}

.ml5 {
  margin-left: 8.4% !important;
}

.ml0 {
  margin-left: 0 !important;
}
</style>
